module.exports = __webpack_public_path__ + "static/media/sat-2.7f695e47.pdf";